import { RegionShared } from "@1games-ru/region-shared";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import toast from "@/domains/toasts/helpers/toast";

export function useVehicleSpawnMutation() {
  const { t } = useTranslation("vehicle");

  return useMutation({
    mutationFn: async (vehicleId: number) => {
      try {
        const response = await VehicleMpProvider.vehicleComplexSummon({
          vehicleId,
        } as typeof RegionShared.Backend.Requests.VehicleComplexSummonRequest);

        if (response instanceof RpcMpProviderFailedResponse) {
          console.error("Failed to spawn vehicle:", response);
          toast.error(t(`spawn.spawnError.${response.message}`));
          return false;
        }

        toast.success(t("spawn.spawnSuccess"));
        return true;
      } catch (error) {
        console.error("Failed to spawn vehicle:", error);
        toast.error(t("spawn.spawnError.general"));
        return false;
      }
    },
  });
}
